import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-iqac-aqar-16-17',
  templateUrl: './iqac-aqar-16-17.component.html',
  styleUrls: ['./iqac-aqar-16-17.component.scss']
})
export class IQACAQAR1617Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
